import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerAdmin } from '../services/api';
import '../styles/AdminRegister.css';

function AdminRegister() {
  const [form, setForm] = useState({ username: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Vérifier que l'admin est connecté
useEffect(() => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    navigate('/admin/login');
  }
}, [navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (form.password !== form.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (form.password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }

    setLoading(true);

    try {
    const response = await registerAdmin({
        username: form.username,
        email: form.email,
        password: form.password,
    });

    if (response.success) {
        setSuccess(`Admin "${form.username}" créé avec succès !`);
        setForm({ username: '', email: '', password: '', confirmPassword: '' });
    }
    } catch (err) {
    setError(err.response?.data?.message || 'Erreur lors de la création');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-register-container">
      <div className="admin-register-box">
        <Link to="/admin/dashboard" className="admin-register-back">
          ← Retour au dashboard
        </Link>

        <h1>➕ Nouvel Admin</h1>
        <p className="admin-register-subtitle">
          Créer un nouveau compte administrateur
        </p>

        {error && <div className="admin-register-message error">{error}</div>}
        {success && <div className="admin-register-message success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="admin-register-field">
            <label htmlFor="username">Nom d'utilisateur</label>
            <input
              id="username"
              type="text"
              name="username"
              placeholder="ex: admin_marie"
              value={form.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="admin-register-field">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              placeholder="ex: marie@asso.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="admin-register-field">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              name="password"
              placeholder="Minimum 6 caractères"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          <div className="admin-register-field">
            <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
            <input
              id="confirmPassword"
              type="password"
              name="confirmPassword"
              placeholder="Retapez le mot de passe"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Création...' : 'Créer l\'admin'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminRegister;